"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reusables_1 = require("../../../../comps/reusables");
const graphql_1 = require("../../../../graphql");
const Yup = tslib_1.__importStar(require("yup"));
const IntegrationSharedSettings_1 = require("../IntegrationSharedSettings");
const ApiCredentialsCard_1 = require("../ApiCredentialsCard");
exports.MailjetSettings = ({ integration }) => {
    return (react_1.default.createElement(reusables_1.Form, { mutationProps: {
            mutation: graphql_1.updateMailjet,
            refetchQueries: [
                {
                    query: graphql_1.integration,
                    variables: {
                        id: integration.id,
                    },
                },
            ],
        }, valuesToVariables: values => {
            return {
                data: {
                    apiPublicKey: values.apiPublicKey.trim(),
                    apiSecretKey: values.apiSecretKey.trim(),
                    name: values.name.trim(),
                },
                id: integration.id,
            };
        }, formikProps: {
            initialValues: {
                apiPublicKey: integration.apiPublicKey,
                apiSecretKey: integration.apiSecretKey,
                name: integration.name,
            },
            validationSchema: () => Yup.object().shape({
                apiPublicKey: Yup.string().trim(),
                apiSecretKey: Yup.string().trim(),
                name: Yup.string()
                    .trim()
                    .required('Required'),
            }),
        }, showBottomToolbar: true }, formikProps => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(IntegrationSharedSettings_1.IntegrationSharedSettings, { integration: integration, formikProps: formikProps, sidebar: react_1.default.createElement(ApiCredentialsCard_1.ApiCredentialsCard, null,
                react_1.default.createElement(reusables_1.FormGroup, { label: "API public key", name: "apiPublicKey", autoComplete: "off" }),
                react_1.default.createElement(reusables_1.FormGroup, { label: "API secret key", name: "apiSecretKey", type: "password", autoComplete: "off" }),
                react_1.default.createElement("p", { className: "mb-0" },
                    react_1.default.createElement("a", { href: "https://app.mailjet.com/account/api_keys", target: "_blank", rel: "noopener noreferrer" }, "Find your API key on mailjet.com"))) })))));
};
// import React from 'react';
// import { Form } from '../../../../comps/reusables';
// import { updateMailjet , integration as integrationQ } from '../../../../graphql';
// import { Mailjet } from '@osmosys/models';
// import * as Yup from 'yup';
// import { IntegrationSharedSettings } from '../IntegrationSharedSettings';
// interface IProps {
//   integration: Mailjet;
//   refetch: () => void;
//   location: Location;
// }
// export class MailjetSettings extends React.Component<IProps, {}> {
//     public render() {
//     return (
//         <Form
//           mutationProps={{
//             mutation: updateMailjet,
//             refetchQueries: [
//               {
//                 query: integrationQ,
//                 variables: {
//                   id: this.props.integration.id,
//                 },
//               },
//             ],
//           }}
//           valuesToVariables={values => {
//             const data = {
//               apiPublicKey: values.apiPublicKey.trim(),
//               apiSecretKey: values.apiSecretKey.trim(),
//               name: values.name.trim(),
//             };
//             return {
//               data,
//               id: this.props.integration.id,
//             };
//           }}
//           formikProps={{
//             initialValues: {
//               apiPublicKey: this.props.integration.apiPublicKey,
//               apiSecretKey: this.props.integration.apiSecretKey,
//               name: this.props.integration.name,
//             },
//             validationSchema: () =>
//               Yup.object().shape({
//                 apiPublicKey: Yup.string().trim(),
//                 apiSecretKey: Yup.string().trim(),
//                 name: Yup.string()
//                   .trim()
//                   .required('Required'),
//               }),
//           }}
//           showBottomToolbar
//         >
//           {formikProps => (
//             <>
//               <IntegrationSharedSettings
//                 integration={this.props.integration}
//                 formikProps={formikProps}
//                 hasAccessKey
//               />
//             </>
//           )}
//         </Form>
//     );
//   }
// }
// END
// export const MailjetSettings: FC<IProps> = ({ integration }) => {
//   return (
//       <Form
//         mutationProps={{
//           mutation: updateMailjet,
//           refetchQueries: [
//             {
//               query: integrationQ,
//               variables: {
//                 id: integration.id,
//               },
//             },
//           ],
//         }}
//         valuesToVariables={values => {
//           const data = {
//             apiPublicKey: values.apiPublicKey.trim(),
//             apiSecretKey: values.apiSecretKey.trim(),
//             name: values.name.trim(),
//           };
//           return {
//             data,
//             id: integration.id,
//           };
//         }}
//         formikProps={{
//           initialValues: {
//             apiPublicKey: integration.apiPublicKey,
//             apiSecretKey: integration.apiSecretKey,
//             name: integration.name,
//           },
//           validationSchema: () =>
//             Yup.object().shape({
//               apiPublicKey: Yup.string().trim(),
//               apiSecretKey: Yup.string().trim(),
//               name: Yup.string()
//                 .trim()
//                 .required('Required'),
//             }),
//         }}
//         showBottomToolbar
//       >
//         {formikProps => (
//           <>
//             <IntegrationSharedSettings
//               integration={integration}
//               formikProps={formikProps}
//               workspaceAdminSettings={
//                 <ApiCredentialsCard>
//                   <FormGroup
//                     label="API public key"
//                     name="apiPublicKey"
//                     autoComplete="off"
//                   />
//                   <FormGroup
//                     label="API secret key"
//                     name="apiSecretKey"
//                     type="password"
//                     autoComplete="off"
//                   />
//                   <p className="mb-0">
//                     <a
//                       href="https://app.mailjet.com/account/api_keys"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                     >
//                       Find your API key on mailjet.com
//                     </a>
//                   </p>
//                 </ApiCredentialsCard>
//               }
//             />
//           </>
//         )}
//       </Form>
//   );
// };
//# sourceMappingURL=MailjetSettings.js.map